<script>
import checkoutMixin from '@/v-shop/checkout/checkout-mixin'
// import { loadScript, unloadScript } from '@/utils/load-script'
// const recaptchaScript = 'https://www.google.com/recaptcha/api.js'

export default {
	lang: 'shop',
	mixins: [checkoutMixin],
	data() {
		return {
			tokensByAfiliado: [],
			recetas: [],
			validation: {},
			loading: true,
			tokenLoading: null,
			firstReload: true,
		}
	},
	computed: {
		canSubmit() {
			return !this.tokensByAfiliado.some((x) => x.needsToken)
		},
	},
	methods: {
		async submit() {
			await this.checkout.stepSubmit({})
		},
		async reloadRecetas() {
			const response = await this.checkout.reqWrapper(({ data, done }) => {
				return this.$shopApi.post({
					url: '/recetadigital/checkout/load-recetas',
					loading: (v) => (this.loading = v),
					data,
					done,
				})
			})

			if (response.success) {
				this.firstReload = false
				this.recetas = response.data.recetas || []
				this.tokensByAfiliado = this.recetas.reduce((tokensByAfiliado, receta) => {
					let obj = tokensByAfiliado.find(
						(x) => x.financiadorKey == receta.financiadorKey && x.nroAfiliado == receta.nroAfiliado
					)
					if (!obj) {
						obj = {
							financiadorKey: receta.financiadorKey,
							financiadorName: receta.financiador.displayName,
							nroAfiliado: receta.nroAfiliado,
							token: '',
							recetas: [],
						}
						tokensByAfiliado.push(obj)
					}
					receta.items = this.checkout.order.items.filter((x) => {
						return (
							x.customization?.key == 'recetadigital' && x.customization.data?.recetaId == receta.id
						)
					})

					receta.items.forEach((item) => {
						let { CodTroquel, DrogaCodigo } = item.customization?.data || {}
						let coberturaItem = receta.coberturaItems.find((x) => {
							if (x.CodTroquel) return x.CodTroquel == CodTroquel
							else return x.Droga.Codigo == DrogaCodigo
						})
						let coberturaDiscount = coberturaItem?.PorcentajeCobertura
							? Number(coberturaItem.PorcentajeCobertura)
							: 0
						if (item.orderDiscountPct >= coberturaDiscount) {
							item.coberturaDiscount = coberturaDiscount
						} else {
							item.coberturaDiscount = 0
						}
					})
					obj.recetas.push(receta)
					obj.needsToken = obj.recetas.some((receta) => receta.forConsume)
					if (obj.needsToken) {
						obj.recetas.sort((a, b) => parseInt(a.forConsume) - parseInt(b.forConsume))
					}
					return tokensByAfiliado
				}, [])
			}
		},

		async submitToken(idx) {
			const obj = this.tokensByAfiliado[idx]

			if (!obj.token || !obj.needsToken) return
			const response = await this.checkout.reqWrapper(({ data, done }) => {
				data = {
					...data,
					financiadorKey: obj.financiadorKey,
					nroAfiliado: obj.nroAfiliado,
					token: obj.token,
				}

				return this.$shopApi.post({
					url: '/recetadigital/checkout/consume-recetas',
					loading: (v) => (this.tokenLoading = v ? idx : null),
					data,
					done,
				})
			})

			if (response.success) {
				this.reloadRecetas()
			}
		},
	},
	mounted() {
		this.reloadRecetas()
		// if (recaptchaPublicKey) {
		// 	this.recaptchaPublicKey = recaptchaPublicKey
		// 	this.$nextTick(() => {
		// 		loadScript(recaptchaScript)
		// 	})
		// }
	},
	beforeDestroy() {
		// if (recaptchaPublicKey) {
		// unloadScript(recaptchaScript)
		// }
	},
}
</script>

<template>
	<div v-if="loading && firstReload" class="w100 d-flex pa-6 justify-center align-center">
		<v-progress-circular indeterminate color="primary" />
	</div>

	<div v-else :class="{ reloading: loading && !firstReload }">
		<div class="d-flex flex-column" style="gap: 32px">
			<div
				v-for="(obj, i) of tokensByAfiliado"
				:key="`afiliado-${i}`"
				class="d-flex flex-column"
				style="gap: 12px"
			>
				<div class="d-flex align-center">
					<div>
						<b class="font-1">Afiliado&nbsp;</b>
						<b class="font-2">{{ obj.financiadorName }} / {{ obj.nroAfiliado }}</b>
					</div>
					<v-spacer />
					<router-link :to="{ name: 'recetadigital' }" class="font-0 indigo--text">
						Modificar medicamentos
					</router-link>
				</div>
				<div
					class="w100 grey lighten-4 rounded-lg px-4 py-2"
					v-for="(receta, j) of obj.recetas"
					:key="`receta-${i}-${j}`"
				>
					<div class="d-flex align-center pb-2">
						<b>Receta #{{ receta.nroReceta }}</b>
						<v-spacer />
						<div v-if="receta.forConsume" class="font-0 warning--text">
							<i>Requiere validación</i>
						</div>
						<div v-else class="font-0 success--text">
							<b>Validada</b>
						</div>
					</div>
					<table class="recetas-items-table w100">
						<tbody>
							<tr v-for="(item, k) of receta.items" :key="`item-${i}-${j}-${k}`">
								<td class="pa-2">x{{ item.qty }}</td>
								<td class="w100 pa-2">
									{{ item.name }}
									<div class="grey--text font-0">{{ item.variantName }}</div>
								</td>
								<td class="pa-2 pr-0 nowrap">
									<v-chip
										small
										:color="item.coberturaDiscount ? 'success' : 'grey darken-2'"
										:outlined="!item.coberturaDiscount"
									>
										<b v-if="item.coberturaDiscount">Cobertura {{ item.coberturaDiscount }}%</b>
										<span v-else>Sin Cobertura</span>
									</v-chip>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="w100 grey lighten-3 rounded-lg px-4 py-4" v-if="obj.needsToken">
					<div class="pb-2 font-weight-bold text-center">
						Ingresa el token para validar las recetas pendientes del afiliado
						{{ obj.financiadorName }} /
						{{ obj.nroAfiliado }}
					</div>
					<div class="d-flex align-center align-sm-start justify-center w100" style="gap: 12px">
						<TextField
							v-model="obj.token"
							:style="{ width: $b.m ? '150px' : '250px' }"
							class="flex-shrink-0 flex-grow-0"
							label=""
							placeholder="Token"
							:error-messages="validation[`tokensByAfiliado.${i}.token`]"
							outlined
							dense
						/>
						<Button
							@click="submitToken(i)"
							color="success"
							:disabled="!obj.token || (tokenLoading !== null && tokenLoading !== i)"
							:loading="tokenLoading === i"
						>
							Enviar
						</Button>
					</div>
				</div>
			</div>
		</div>

		<!-- captcha -->
		<!-- <div class="d-flex flex-column justify-center align-center text-center" style="height: 88px">
				<div v-if="checkout.validation.captcha" class="font-0 pb-2" style="color: red">
					<b> Por favor, complete el captcha para continuar.</b>
				</div>
				<div class="g-recaptcha" :data-sitekey="recaptchaPublicKey"></div>
			</div> -->

		<div class="pt-8">
			<Button
				@click="checkout.stepSubmit({})"
				color="success"
				block
				:disabled="!canSubmit"
				:loading="checkout.loadingSubmit"
			>
				Continuar
			</Button>
		</div>
	</div>
</template>

<style lang="scss" scoped>
.reloading {
	opacity: 0.5;
	pointer-events: none;
}
.reloading *,
.reloading ::v-deep * {
	pointer-events: none;
}
.recetas-items-table {
	td {
		vertical-align: top;
		border-top: 1px solid #ccc;
	}
}
</style>

